<template>
    <div>
        <el-card>
    <el-table :data="tableData" ref="historyTable" size=mini highlight-current-row v-loading="loading" :header-cell-style = "{background:'#987AFF'}" :height='isMobile ? 400 : 600' :element-loading-text="$t('meterRecord.拼命加载中')">
    <el-table-column v-if="!isMobile" type="index" width="100" />
    <el-table-column property="meterId" :label="$t('meterRecord.水表编号')" :width="isMobile ? '' : 171" />
    <el-table-column property="sumFlow" :label="$t('meterRecord.累计总用量')" :width="isMobile ? '' : 171" :show-overflow-tooltip="true" />
    <el-table-column v-if="!isMobile" property="unit" :label="$t('meterRecord.单位')" width="171" />
    <el-table-column v-if="!isMobile" property="plotReceiveTime" :label="$t('meterRecord.抄表时间')" width="171" :show-overflow-tooltip="true" />
    <el-table-column v-if="!isMobile" property="netAccumulation" :label="$t('meterRecord.净累计流量')" width="150" />
    <el-table-column v-if="!isMobile" property="reverseAccumulation" :label="$t('meterRecord.反向累计流量')" width="170" />
    <el-table-column v-if="!isMobile" property="atAccumulation" :label="$t('meterRecord.瞬时流量')" width="100" />
    <el-table-column v-if="!isMobile" property="batteryVoltage" :label="$t('meterRecord.电池电压')" width="150" />
    <el-table-column v-if="!isMobile" property="signallntensity" :label="$t('meterRecord.信号强度')" width="150" />
    <el-table-column v-if="!isMobile" property="powerDown" :label="$t('meterRecord.掉电状态')" width="100" />
    <el-table-column v-if="!isMobile" property="powerLow" :label="$t('meterRecord.低压状态')" width="100" />
    <el-table-column v-if="!isMobile" property="magneticAttack" :label="$t('meterRecord.磁攻击')" width="150" />
    <el-table-column v-if="!isMobile" property="valveStatus" :label="$t('meterRecord.阀门状态')" width="172" />
    <el-table-column v-if="isMobile" label="操作" :width="90">
      <template slot-scope="scope">
        <el-button size="mini" type="primary" @click="showDetail(scope.row)">详情</el-button>
      </template>
    </el-table-column>
  </el-table>
  <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="watefamls.pagenum"
      :page-sizes="[20, 40, 60, 80, 100]"
      :page-size="watefamls.pagesize"
      :small="isMobile"
      :pager-count="isMobile ? 5 : 7"
      :layout="isMobile ? 'prev, pager, next' : 'total, sizes, prev, pager, next, jumper'"
      :total="total">
    </el-pagination>

  <el-dialog title="详情" :visible.sync="mobileDetailVisible" width="92%" class="mobile-detail-dialog">
    <div class="mobile-detail-content">
      <div v-for="item in mobileDetailItems" :key="item.key">
        <span>{{ item.label }}：</span>{{ item.value }}
      </div>
    </div>
    <span slot="footer">
      <el-button type="primary" size="mini" @click="mobileDetailVisible = false">关闭</el-button>
    </span>
  </el-dialog>
      </el-card>
    </div>
</template>

<script>
export default {
  data () {
    return {
    // 手机端
      isMobile: false,
    // table数据
      tableData: [{
        meterId: null,
        sumFlow: null,
        unit: null,
        insertTime: null,
        valveStatus: null
      }],
      // tab数据加载转圈
      loading: false,
      total: 0,
      mobileDetailVisible: false,
      mobileDetailRow: {},
      watefamls: {
        meter_id: null,
        token: null,
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少条数据
        pagesize: 20
      }
    }
  },
  computed: {
    mobileDetailItems () {
      const row = this.mobileDetailRow || {}
      const fieldMap = [
        { key: 'meterId', label: this.$t('meterRecord.水表编号') },
        { key: 'sumFlow', label: this.$t('meterRecord.累计总用量') },
        { key: 'unit', label: this.$t('meterRecord.单位') },
        { key: 'plotReceiveTime', label: this.$t('meterRecord.抄表时间') },
        { key: 'netAccumulation', label: this.$t('meterRecord.净累计流量') },
        { key: 'reverseAccumulation', label: this.$t('meterRecord.反向累计流量') },
        { key: 'atAccumulation', label: this.$t('meterRecord.瞬时流量') },
        { key: 'batteryVoltage', label: this.$t('meterRecord.电池电压') },
        { key: 'signallntensity', label: this.$t('meterRecord.信号强度') },
        { key: 'powerDown', label: this.$t('meterRecord.掉电状态') },
        { key: 'powerLow', label: this.$t('meterRecord.低压状态') },
        { key: 'magneticAttack', label: this.$t('meterRecord.磁攻击') },
        { key: 'valveStatus', label: this.$t('meterRecord.阀门状态') }
      ]
      return fieldMap.map(item => ({
        key: item.key,
        label: item.label,
        value: row[item.key] === null || row[item.key] === undefined || row[item.key] === '' ? '-' : row[item.key]
      }))
    }
  },
  created () {
    this.updateIsMobile()
    this.watefamls.token = this.$store.state.print.goodsForeNo.token
    console.log(this.$parent.meterMaid, '获取父组件的表号')
    this.watefamls.meter_id = this.$parent.meterMaid
    this.metnData()
    this.resetScrollPosition()
  },
  mounted () {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateIsMobile)
  },
  methods: {
    updateIsMobile () {
      this.isMobile = typeof window !== 'undefined' && window.innerWidth <= 768
    },
    showDetail (row) {
      this.mobileDetailRow = row || {}
      this.mobileDetailVisible = true
    },
    // 封装滚动条重置逻辑
    // 封装滚动条重置逻辑
    resetScrollPosition (direction = 'both') {
      this.$nextTick(() => {
        const tableRef = this.$refs.historyTable
        if (!tableRef?.$el) return

        const scrollBody = tableRef.$el.querySelector('.el-table__body-wrapper')
        if (!scrollBody) return

        // 现代浏览器推荐使用 scrollTo
        switch (direction) {
          case 'vertical':
            scrollBody.scrollTo({ top: 0, behavior: 'auto' })
            break
          case 'horizontal':
            scrollBody.scrollTo({ left: 0, behavior: 'auto' })
            break
          default: // both
            scrollBody.scrollTo({ top: 0, left: 0, behavior: 'auto' })
        }

        // 兼容写法（Vue2旧项目可能需要）
        // if (direction === 'vertical' || direction === 'both') {
        //   scrollBody.scrollTop = 0
        // }
        // if (direction === 'horizontal' || direction === 'both') {
        //   scrollBody.scrollLeft = 0
        // }
      })
    },
    metnData () {
      this.$api.waterMeter.wateDatas(this.watefamls).then((res) => {
        if (res.data.status === 'success') {
          console.log(res, '抄表记录')
          this.tableData = res.data.data
          this.total = res.data.total
          this.resetScrollPosition()
        }
      })
    },
    // 监听 pagesize 改变的事件
    handleSizeChange (newSize) {
      console.log(newSize, 'q')
      this.watefamls.pagesize = newSize
      this.metnData()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange (newPage) {
      console.log(newPage)
      this.watefamls.pagenum = newPage
      this.metnData()
    }
  }
}
</script>

<style lang="less" scoped>
.el-card{
          border-radius: 10px;
          ::v-deep .el-card__body{
            padding: 0px;
          }
          ::v-deep .el-table__header-wrapper{
            background-color: #987AFF;
              width: 100%;
          }
          ::v-deep .el-table tr{
            background-color: #F9F9F9;
          }
          ::v-deep .el-table thead{
            color: #fff;
            font-weight: 300;
          }
         ::v-deep .cell{
           font-family:myFont;
          }
        }
        ::v-deep .cell{
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          text-align: center;
        }
       ::v-deep .el-table__header{
         width: 0;
          width: 100%;
        }
        .el-button{
          border: 1px solid #744dfe;
        }
@media (max-width: 768px) {
  ::v-deep .el-table__body-wrapper{
    overflow-x: hidden !important;
  }
  ::v-deep .el-table__header-wrapper{
    overflow-x: hidden !important;
  }
  ::v-deep .el-pagination{
    display: flex;
    justify-content: center;
    margin: 10px 0 4px;
  }
  .mobile-detail-dialog{
    .mobile-detail-content{
      max-height: 60vh;
      overflow-y: auto;
      div{
        line-height: 22px;
        margin-bottom: 6px;
        word-break: break-all;
        span{
          color: #606266;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
